import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'react-bootstrap5';

import ProgressBar from 'components/Widgets/ProgressBar';

import { useParams } from 'react-router-dom';
import axios from 'axios';
import routes from 'app/routes';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext as useUsersContext } from 'components/Users/Context';
import BlockText from './BlockText';
import Form from './Form';

import Skip from './Skip';

export default function Index({ onNextStep, title }) {
  const defaultBlock = 'block1';
  const visibleBlocks = localStorage.getItem('talentAssessmentVisibleBlocks')?.split(',') || [defaultBlock];
  const [activeBlock, setActiveBlock] = useState(visibleBlocks[visibleBlocks.length - 1]);
  const [progress, setProgress] = useState(0);

  const [showSkip, setShowSkip] = useState(false);

  const { programId, typeAssessment } = useParams();

  const { state: stateUser } = useUsersContext();

  const onCloseSkip = () => {
    setShowSkip(false);
  };

  const onSkipNow = () => {
    axios
      .get(routes.api.career_pulse_assessment_reports.skip, {
        params: {
          program_id: programId,
          type_assessment: typeAssessment,
        },
      })
      .then(() => {
        onCloseSkip();
        document.location.href = '/members/programs';
      });
  };

  useEffect(() => {
    let text = 'Please complete your Talent Assessment before exploring the LeggUP platform!';

    const showPopup = (e) => {
      e.stopPropagation();
      e.preventDefault();
      Alert({ text });
    };

    if (programId !== undefined && typeAssessment !== undefined) {
      if (stateUser.user && !stateUser.user.attributes.is_mobile_login) {
        axios
          .get(routes.api.career_pulse_assessment_reports.possibleSkip, {
            params: {
              program_id: programId,
              type_assessment: typeAssessment,
            },
          })
          .then((resp) => {
            const requiredAction = resp.data.data;
            if (requiredAction.attributes.possible_skip) {
              setShowSkip(true);
            }
          });
      }

      if (typeAssessment === 'first') {
        text = 'Please complete your Talent Assessment before your session with your coach.';
      }

      document.querySelectorAll('a').forEach((element) => {
        element.addEventListener('click', showPopup);
      });
    }

    return () => {
      document.querySelectorAll('a').forEach((element) => {
        element.removeEventListener('click', showPopup);
      });
    };
  }, [stateUser.user]);

  return (
    <div className="content">
      <section>
        <Row>
          <Col lg={8}>
            <h1 className="mb-3">{title}</h1>
          </Col>

          <Col lg={4} className="mb-4 mt-lg-0">
            <ProgressBar now={progress} />
          </Col>
        </Row>

        <Row>
          <Col>
            <BlockText block={activeBlock} />
          </Col>
        </Row>
      </section>

      <Form
        activeBlock={activeBlock}
        setActiveBlock={(block) => {
          setActiveBlock(block);

          const pastBlocks = localStorage.getItem('talentAssessmentVisibleBlocks')?.split(',') || [defaultBlock];
          pastBlocks.push(block);
          localStorage.setItem('talentAssessmentVisibleBlocks', pastBlocks);
        }}
        setProgress={setProgress}
        onNextStep={onNextStep}
      />
      {showSkip && <Skip onCloseSkip={onCloseSkip} onSkipNow={onSkipNow} />}
    </div>
  );
}

Index.propTypes = {
  onNextStep: PropTypes.func,
  title: PropTypes.string,
};

Index.defaultProps = {
  onNextStep: undefined,
  title: 'Talent Assessment',
};
